import { CheckPayment } from "@/features/payment-form";
import { Layout } from "../Layout";

export const CheckPaymentPage = () => {
  return (
    <Layout>
      <CheckPayment />
    </Layout>
  );
};
